import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type Lang = 'fr' | 'ar';

interface UIState {
  sidebarCollapsed: boolean;
  /** Tiroir de navigation mobile (overlay) — transitoire, non persisté. */
  mobileOpen: boolean;
  lang: Lang;
  toggleSidebar: () => void;
  setSidebarCollapsed: (collapsed: boolean) => void;
  setMobileOpen: (open: boolean) => void;
  setLang: (lang: Lang) => void;
}

/**
 * État d'interface global (préférences d'affichage). Persisté dans
 * localStorage — uniquement des préférences non sensibles (brief sécurité :
 * aucune donnée sensible en localStorage).
 */
export const useUIStore = create<UIState>()(
  persist(
    (set) => ({
      sidebarCollapsed: false,
      mobileOpen: false,
      lang: 'fr',
      toggleSidebar: () => set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed })),
      setSidebarCollapsed: (collapsed) => set({ sidebarCollapsed: collapsed }),
      setMobileOpen: (open) => set({ mobileOpen: open }),
      setLang: (lang) => set({ lang }),
    }),
    // On ne persiste QUE les préférences (pas l'état transitoire du tiroir mobile).
    { name: 'horizon-ui', partialize: (s) => ({ sidebarCollapsed: s.sidebarCollapsed, lang: s.lang }) },
  ),
);
